import { useEffect, useRef } from 'react';

const Optimizely = () => {
  const scriptRef = useRef<HTMLScriptElement | null>(null);

  useEffect(() => {
    const isHomePage = window?.location?.pathname === '/';
    const hasQueryParams = window?.location?.search?.length > 0;
    const shouldHaveScript = isHomePage && hasQueryParams;

    // If we already have a script and shouldn't, remove it
    if (scriptRef.current && !shouldHaveScript) {
      scriptRef.current.remove();
      scriptRef.current = null;
      return;
    }
    // If we don't have a script and should, add it
    if (!scriptRef.current && shouldHaveScript) {
      const script = document.createElement('script');
      script.src = 'https://cdn.optimizely.com/js/6209881250725888.js';
      scriptRef.current = script;
      document.head.appendChild(script);
    }
  }, []);

  return null;
};

export default Optimizely; 
